import { calculatePageCount, calculatePageSegment } from '../Common/utils';

export const getCurrentSelectedVisit = state => state.visits.currentSelectedVisit;

export const getCurrentOverviewDetails = state => state.visits.currentVisitsDetails.overview;

export const getCurrentAggregatorPayloadDetails = state =>
  state.visits.currentVisitsDetails.aggregatorPayload;

export const getCurrentVisitPayloadDetails = state =>
  state.visits.currentVisitsDetails.visitPayload;

export const getCurrentHistoryDetails = state => state.visits.currentVisitsDetails.history;

export const selectVisitsFilters = state => state.visits.visitsFilters;

export const selectVisitsReports = state => state.visits.visitsList.list || [];
export const selectVisitGridIsLoading = state => state.visits.visitsList.isLoading || false;
export const selectVisitTotalRecords = state => state.visits.visitsList.totalRecords || false;

export const getVisitsPagination = state => {
  const { pageNumber, pageSize } = selectVisitsFilters(state);
  const totalRecords = selectVisitTotalRecords(state);
  const pageCount = calculatePageCount(pageSize)(totalRecords);
  const pagesPerSegment = calculatePageSegment(pageCount);

  return {
    pageNumber,
    numberOfPages: pageCount,
    pagesPerSegment,
    totalRecords,
    pageSize,
  };
};

export const getVisitsGridSortCriteria = state => state.visits.visitsGridSortCriteria;
